import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';

import * as HyundaiMenuNgrxActions from './hyundai-menu-ngrx.actions';
import * as HyundaiMenuNgrxFeature from './hyundai-menu-ngrx.reducer';

@Injectable()
export class HyundaiMenuNgrxEffects {
  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HyundaiMenuNgrxActions.init),
      fetch({
        run: (action) => {
          // Your custom service 'load' logic goes here. For now just return a success action...
          return HyundaiMenuNgrxActions.loadHyundaiMenuNgrxSuccess({ hyundaiMenuNgrx: [] });
        },
        onError: (action, error) => {
          console.error('Error', error);
          return HyundaiMenuNgrxActions.loadHyundaiMenuNgrxFailure({ error });
        },
      })
    )
  );

  constructor(private readonly actions$: Actions) {}
}
